<div class="gruppe-auswahl-shell">
    <div mat-dialog-title class="gruppe-auswahl-header">
        <div class="gruppe-auswahl-header__copy">
            <h1>Gruppe ausw&auml;hlen</h1>
            <p>{{ data?.subtitle || 'Wähle die gewünschte Gruppe.' }}</p>
        </div>
        <button
            type="button"
            class="gruppe-auswahl-header__close"
            mat-icon-button
            aria-label="Schließen"
            (click)="close()"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="gruppe-auswahl-content">
        <div class="gruppe-auswahl-loading" *ngIf="isLoading">
            <mat-spinner diameter="36"></mat-spinner>
            <span>Gruppen werden geladen&hellip;</span>
        </div>

        <ng-container *ngIf="!isLoading">
            <section class="gruppe-auswahl-top" *ngIf="selectedVVVO || data?.mehrereGruppen">
                <div *ngIf="selectedVVVO" class="gruppe-auswahl-betrieb-card">
                    <div class="gruppe-auswahl-betrieb-card__icon">
                        <mat-icon>home_work</mat-icon>
                    </div>
                    <div class="gruppe-auswahl-betrieb-card__content">
                        <div class="gruppe-auswahl-betrieb-card__display-name">
                            {{ selectedVVVO.bezeichnung_final || selectedVVVO.vvvo }}
                        </div>
                        <div class="gruppe-auswahl-betrieb-card__label">Betrieb</div>
                        <div class="gruppe-auswahl-betrieb-card__vvvo">{{ selectedVVVO.vvvo }}</div>
                        <div class="gruppe-auswahl-betrieb-card__name">
                            {{ selectedVVVO.bezeichnung_final }}<span
                                class="gruppe-auswahl-betrieb-card__zusatz"
                                *ngIf="selectedVVVO.zusatz_final"
                            >
                                &ndash; {{ selectedVVVO.zusatz_final }}</span
                            >
                        </div>
                    </div>
                </div>

                <button
                    *ngIf="data?.mehrereGruppen"
                    class="gruppe-auswahl-multi-cta"
                    type="button"
                    (click)="mehrereGruppen()"
                >
                    <span class="gruppe-auswahl-multi-cta__icon">
                        <mat-icon>dynamic_feed</mat-icon>
                    </span>
                    <span class="gruppe-auswahl-multi-cta__text">Global</span>
                    <mat-icon class="gruppe-auswahl-multi-cta__chevron" aria-hidden="true">chevron_right</mat-icon>
                </button>
            </section>

            <section class="gruppe-auswahl-groups" *ngIf="gruppen?.length > 0">
                <div *ngIf="data?.mehrereGruppen" class="gruppe-auswahl-groups__label">Einzelne Gruppe</div>

                <div class="gruppe-auswahl-search">
                    <mat-icon>search</mat-icon>
                    <input
                        type="search"
                        [(ngModel)]="searchQuery"
                        placeholder="Gruppe, Stall oder Tiere suchen"
                        aria-label="Gruppen suchen"
                    />
                </div>

                <div
                    class="gruppe-auswahl-list"
                    *ngIf="filteredGruppen.length > 0"
                    [class.gruppe-auswahl-list--single-betrieb]="!!selectedVVVO"
                >
                    <div class="gruppe-auswahl-list__head" aria-hidden="true">
                        <span>Gruppe</span>
                        <span class="gruppe-auswahl-list__head-client">Betrieb</span>
                        <span>Standort</span>
                        <span>Tiere</span>
                        <span></span>
                    </div>

                    <article
                        class="gruppe-auswahl-card"
                        *ngFor="let g of filteredGruppen"
                        role="button"
                        tabindex="0"
                        (click)="hinzufuegen(g)"
                        (keydown.enter)="hinzufuegen(g)"
                        (keydown.space)="hinzufuegen(g); $event.preventDefault()"
                    >
                        <div class="gruppe-auswahl-card__body">
                            <div class="gruppe-auswahl-card__name">{{ g.bezeichnung }}</div>
                            <div class="gruppe-auswahl-card__client" *ngIf="!selectedVVVO">
                                {{ g.kunde }}<ng-container *ngIf="g.zusatz"> &ndash; {{ g.zusatz }}</ng-container>
                            </div>
                            <div class="gruppe-auswahl-card__meta">{{ getGruppeMeta(g) || '—' }}</div>
                            <div class="gruppe-auswahl-card__count">
                                <span class="gruppe-auswahl-card__count-value">{{ g.anzahl_tiere_aktuell ?? 0 }}</span>
                                <span class="gruppe-auswahl-card__count-label">Tiere aktuell</span>
                            </div>
                        </div>
                        <mat-icon class="gruppe-auswahl-card__chevron" aria-hidden="true">chevron_right</mat-icon>
                    </article>
                </div>

                <div class="gruppe-auswahl-empty" *ngIf="filteredGruppen.length === 0">
                    Keine Gruppe passend zur Suche gefunden.
                </div>
            </section>

            <div class="gruppe-auswahl-empty" *ngIf="gruppen?.length === 0">Noch keine Gruppen angelegt.</div>
        </ng-container>
    </div>

    <div mat-dialog-actions class="gruppe-auswahl-actions">
        <button mat-stroked-button type="button" (click)="close()">Abbrechen</button>
    </div>
</div>
